import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_1d853680";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_1d853680" };
/** script content **/
require("./icon.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex1d853680%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ficon%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_1d853680"],
    ctorType: "component",
    outputPath: "components/index1d853680/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
